import React, { useEffect, useState, useRef }  from 'react';
import { Button } from '@arnsbogroup/react-voicearchive'
import HandoversWidget from './components/HandoversWidget';
import { Widget } from '../../rest/views/Dashboard/Widget';
import AutomatedOrdersWidget from './components/AutomatedOrdersWidget';
import MyOrderWidget from './components/MyOrderWidget';
import Announcement from '../../rest/views/Dashboard/Announcement';
import MyActionTaskWidget from './components/MyActionTaskWidget';
import MyBookingsWidget from './components/MyBookingsWidget';
import OrderListWidget from './components/OrderListWidget';
import ReleasedNotDownloadedTasksWidget from './components/ReleasedNotDownloadedTasksWidget';
import NonAvailableSuppliersWidget from './components/NonAvailableSuppliersWidget';
import PendingQualityCheckWidget from './components/PendingQualityCheckWidget';
import MyLatestViewedWidget from './components/MyLatestViewedWidget';

const COLUMN_INDEXES = [1, 2, 3];

const CoordinatorDashboardPage = () => {
  const mounted = useRef(false);

  const [widgets, setWidgets] = useState([]);

  useEffect(() => {
    mounted.current = true;
    document.title = 'Dashboard';
    fetchWidgets();

    return () => {
      mounted.current = false;
    };
  }, []);

  const fetchWidgets = () => {
    setWidgets([]);
    fetch('/rest/v1/widget')
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setWidgets(data);
      }
    });
  };

  const widgetsByColumnId = (columnId) => {
    return widgets.filter(widget => widget.columnId == columnId);
  }

  return (
    <div className="mainDashboard flex flex-col w-full h-full antialiased text-sm">
      
      <Announcement />

      <div className="w-full pt-1 px-5 flex justify-between items-center text-sm">
        <Button
          variant="inline"
          onClick={() => fetchWidgets()}
          icon={['fa', 'redo-alt']}
          iconPosition="right"
        >
          Reload
        </Button>
      </div>

      <div className="grow">
        {COLUMN_INDEXES.map((index) => (

          <ul key={index} className="w-full md:w-1/3 float-left clear-none list-none min-h-full">

            { widgetsByColumnId(index).map((widget) => {

              if (widget.widgetId == 'Handovers') {
                return <HandoversWidget key={widget.widgetId} widget={widget} />
              }

              if (
                widget.widgetId == 'Latest_Orders' ||
                widget.widgetId == 'Ready_For_Invoicing' ||
                widget.widgetId == 'Orders_under_surveillance' ||
                widget.widgetId == 'Close_To_Deadline' ||
                widget.widgetId == 'Passed_Deadline' ||
                widget.widgetId == 'Closed_But_Not_Invoiced_Orders'
              ) {
                return <OrderListWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'My_Action_Tasks') {
                return <MyActionTaskWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'My_Latest_Viewed') {
                return <MyLatestViewedWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'My_Bookings') {
                return <MyBookingsWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'Released_Not_Downloaded_Tasks') {
                return <ReleasedNotDownloadedTasksWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'Non_Available_Suppliers') {
                return <NonAvailableSuppliersWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'Pending_Quality_Check') {
                return <PendingQualityCheckWidget key={widget.widgetId} widget={widget} />
              }

              if (widget.widgetId == 'My_Orders') {
                return <MyOrderWidget key={widget.widgetId} widget={widget} />
              }
        
              if (widget.widgetId == 'Automated_Orders') {
                return <AutomatedOrdersWidget key={widget.widgetId} widget={widget} />
              }
        
              return <Widget key={widget.widgetId} {...widget} />
            }) }

          </ul>

        ))}
      </div>

    </div>
  );
}

export default CoordinatorDashboardPage;
